var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccessTimeSGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 2.5C6.97 2.5 2.5 6.98 2.5 12.5C2.5 18.02 6.97 22.5 12.49 22.5C18.02 22.5 22.5 18.02 22.5 12.5C22.5 6.98 18.02 2.5 12.49 2.5ZM12.5 20.5C8.08 20.5 4.5 16.92 4.5 12.5C4.5 8.08 8.08 4.5 12.5 4.5C16.92 4.5 20.5 8.08 20.5 12.5C20.5 16.92 16.92 20.5 12.5 20.5Z",
    fill: "#008148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5H11.5V13.5L16.75 16.65L17.5 15.42L13 12.75V7.5Z",
    fill: "#008148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccessTimeSGreen);
export default __webpack_public_path__ + "static/media/icon-access_time-s-green.0c9b700655ccf64dd18ed5268333fb05.svg";
export { ForwardRef as ReactComponent };